<template>
  <div>
    <van-cell-group>
      <van-cell :title="$t('column.Add_item')" is-link @click="addShop"/>
      <van-cell :title="$t('column.Product_list')" is-link @click="shop_product_list"/>
    </van-cell-group>
  </div>
</template>

<script>
    export default {
        name: "shop_manage",
        created: function () {
            document.title = this.$t('title.shop_manage');
        },
        methods: {
            addShop: function () {
                //添加商品
                const token = this.$route.query.token;
                this.$router.push({path: '/shop_add', query: {token: token}});
            },
            shop_product_list: function () {
                //添加商品
                const token = this.$route.query.token;
                this.$router.push({path: '/shop_product_list', query: {token: token}});
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shop_manage.vue